import React from 'react';
import { Link } from 'react-router-dom';
import { siteChromeEn } from '../../content/siteChrome.en';
import { getAppVersionLabel } from '../../utils/appVersion';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  const version = getAppVersionLabel();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <nav className={styles.links} aria-label="Footer">
          <Link to="/terms" className={styles.link}>
            {siteChromeEn.footer.terms}
          </Link>
          <span className={styles.dot} aria-hidden="true">
            •
          </span>
          <Link to="/privacy" className={styles.link}>
            {siteChromeEn.footer.privacy}
          </Link>
          <span className={styles.dot} aria-hidden="true">
            •
          </span>
          <Link to="/app" className={styles.link}>
            {siteChromeEn.footer.getApp}
          </Link>
        </nav>
        <p className={styles.version}>
          {version}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
